<template>
    <div v-if="items.length > 0" class="c-social">
        <h3 class="font-bold text-base mb-2">
            {{model.footer.followUsText}}
        </h3>
        <div class="c-social__links">
            <div v-for="link in items" :key="link.title" class="mb-4">
                <epi-link :target="link.target" :title="link.title" :url="link.href" class="flex items-center">
                    <div v-if="link.isBrand">
                        <font-awesome-icon class="fa-lg" :icon="[ 'fab', link.icon ]" /><span class="pl-2">{{link.text}}</span>
                    </div>
                    <div v-if="!link.isBrand">
                        <font-awesome-icon class="fa-lg" :icon="link.icon" /><span class="pl-2">{{link.text}}</span>
                    </div>
                </epi-link>
            </div>
        </div>
    </div>
</template>

<script>
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';

export default {
    props: ['model'],
    components: {
        EpiLink
    },
    data() {
        let items = [];
        if (this.model.footer.socialLinks) {
            items = this.model.footer.socialLinks.map(link => ({
                ...link,
                icon: this.mapIcon(link.title.toLowerCase()),
                isBrand: this.mapBrand(link.title.toLowerCase())
            }));
        }
        return {
            items: items
        };
    },
    methods: {
        log(msg) {
            console.log(msg);
        },
        mapIcon(name) {
            switch (name) {
                case 'facebook':
                    return 'facebook-square';
                case 'nyhetsbrev':
                    return 'envelope-square';
                default:
                    return null;
            }
        },
        mapBrand(name) {
            switch (name) {
                case 'facebook':
                    return true;
                default:
                    return false;
            }
        }
    }
};
</script>
